import { gsap } from 'gsap';

export default {
	name: 'default',
	leave({ current, next, trigger }) {
		return new Promise((resolve) => {
			gsap.to(current.container, {
				opacity: 0,
				ease: 'none',
				duration: 0.3,
				onComplete: () => {
					resolve();
				},
			});
		});
	},

	afterLeave({ current, next, trigger }) {
		gsap.set(current.container, {
			position: 'absolute',
		});

		gsap.set(next.container, {
			opacity: 0,
		});
	},

	after({ current, next, trigger }) {
		return new Promise((resolve) => {
			gsap.to(next.container, {
				opacity: 1,
				ease: 'none',
				duration: 0.3,
				onComplete: () => {
					resolve();
				},
			});
		});
	},
};
